import { render, staticRenderFns } from "./agency-building.vue?vue&type=template&id=043b4e67&"
import script from "./agency-building.vue?vue&type=script&lang=js&"
export * from "./agency-building.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports